import * as Yup from 'yup';

export const schema = () =>
  Yup.object().shape({
    amount: Yup.number().required('مقدار محصول ضروری می باشد.'),
  });
